import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const navy = [25, 62, 84];
const ink = [36, 59, 83];
const muted = [82, 101, 121];
const green = [23, 98, 58];
const printable = (value) => String(value ?? "No disponible").replace(/[\u00a0\u202f]/g, " ");

export function createPaymentReceiptPdf(
  receipt,
  { logoDataUrl = null, issuedAt = new Date() } = {}
) {
  const doc = new jsPDF({ unit: "mm", format: "a4", compress: true });
  const margin = 16,
    width = 178;
  doc.setProperties({
    title: "Comprobante de pago",
    subject: `Factura ${receipt.facturaNumero}`,
    creator: "GoPass",
  });
  doc.setFont("helvetica", "normal");
  if (logoDataUrl) {
    const image = doc.getImageProperties(logoDataUrl);
    const height = Math.min(13, (44 * image.height) / image.width);
    doc.addImage(logoDataUrl, "PNG", margin, 17, (height * image.width) / image.height, height);
  } else {
    doc
      .setFont("helvetica", "bold")
      .setFontSize(22)
      .setTextColor(...green);
    doc.text("gopass", margin, 27);
  }
  doc
    .setFont("helvetica", "normal")
    .setFontSize(9)
    .setTextColor(...muted);
  doc.text("Pagos Automáticos de Colombia", 194, 21, { align: "right" });
  doc.text("Portal de Recaudos", 194, 27, { align: "right" });

  doc.setFillColor(...navy).roundedRect(margin, 41, width, 27, 3, 3, "F");
  doc.setFont("helvetica", "bold").setFontSize(18).setTextColor(255, 255, 255);
  doc.text("Comprobante de pago", 23, 53);
  doc.setFont("helvetica", "normal").setFontSize(9).setTextColor(218, 233, 242);
  doc.text("Recaudo / Detalle de la transacción", 23, 61);

  doc.setFillColor(237, 247, 241).setDrawColor(200, 227, 210);
  doc.roundedRect(margin, 76, width, 34, 3, 3, "FD");
  doc.setFontSize(9).setTextColor(56, 98, 74);
  doc.text("Valor de la transacción / COP", 23, 86);
  doc
    .setFont("helvetica", "bold")
    .setFontSize(24)
    .setTextColor(...green);
  const amount = printable(
    new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      maximumFractionDigits: 0,
    }).format(receipt.monto)
  );
  doc.text(amount, 23, 101);
  const status = printable(receipt.estado);
  doc.setFontSize(10);
  const badgeWidth = Math.min(64, doc.getTextWidth(status) + 12);
  const statusLines = doc.splitTextToSize(status, badgeWidth - 8);
  doc
    .setFillColor(213, 237, 223)
    .roundedRect(
      187 - badgeWidth,
      85,
      badgeWidth,
      Math.max(11, statusLines.length * 5 + 5),
      3,
      3,
      "F"
    );
  doc.text(statusLines, 187 - badgeWidth / 2, 92, { align: "center" });

  doc
    .setFont("helvetica", "bold")
    .setFontSize(11)
    .setTextColor(...navy);
  doc.text("Información del pago", margin, 125);
  autoTable(doc, {
    startY: 131,
    body: [
      ["Número de factura", receipt.facturaNumero],
      ["Empresa / Usuario", receipt.empresa],
      ["NIT / Identificación", receipt.nit],
      ["Fecha y hora / Bogotá", receipt.fecha],
      ["ID de transacción", receipt.transactionId],
    ].map((row) => row.map(printable)),
    theme: "plain",
    styles: {
      font: "helvetica",
      fontSize: 10,
      cellPadding: 5,
      textColor: ink,
      overflow: "linebreak",
      valign: "middle",
      lineColor: [220, 229, 237],
      lineWidth: { bottom: 0.2 },
    },
    columnStyles: {
      0: { cellWidth: 52, fontSize: 9, textColor: muted },
      1: { cellWidth: 126, fontStyle: "bold" },
    },
    alternateRowStyles: { fillColor: [245, 248, 251] },
    margin: { left: margin, right: margin, top: 20, bottom: 32 },
    rowPageBreak: "avoid",
  });
  const total = doc.getNumberOfPages();
  const emitted = printable(
    issuedAt.toLocaleString("es-CO", { timeZone: "America/Bogota", hour12: false })
  );
  for (let page = 1; page <= total; page++) {
    doc.setPage(page);
    doc.setDrawColor(220, 229, 237).setLineWidth(0.3).line(margin, 265, 194, 265);
    doc
      .setFont("helvetica", "normal")
      .setFontSize(8)
      .setTextColor(...muted);
    doc.text("Comprobante generado a partir de la información del pago registrado.", margin, 272);
    doc.text(`Emisión / Bogotá: ${emitted}`, margin, 279);
    doc.text(`${page} / ${total}`, 194, 279, { align: "right" });
  }
  return doc;
}
